import { makeAutoObservable } from 'mobx';
import { IPresenterSlideEntity } from '../presenter-slide-entity/presenter-slide-entity';
import {
  CuePointMetadata,
  SourceWithoutProperties
} from '../presentation-config-aggregate-types/presentation-config-aggregate-types';
import SlideManagementEntity from '../slide-managment-entity/slide-management-entity';

interface IPresenterActivePointer {
  getActiveItem(): IPresenterSlideEntity;

  getLargeThumbnail(): string;

  getSmallThumbnail(): string;

  getCurrentCuePointId(): string;

  getCurrentCuePointIndex() : number;

  setActiveItem(slide: IPresenterSlideEntity): void;

  updateCurrentIndexAfterWSChanges(slides: IPresenterSlideEntity[]): void;
}

class PresenterActivePointer implements IPresenterActivePointer{
  private activeItem: IPresenterSlideEntity;
  private currentCuePointId: string;
  private currentCuePointIndex: number;

  constructor (
    private readonly slideManagementEntity: SlideManagementEntity,
  ) {
    this.init();
  }

  private init = (): void => {
    makeAutoObservable(this);
    this.currentCuePointId = '';
    this.currentCuePointIndex = 0;
  };

  public getActiveItem = (): IPresenterSlideEntity => {
    return this.activeItem;
  };

  public getLargeThumbnail = (): string => {
    const [ metadata, source ] = this.getActiveItemThumbnailWithSource();
    return metadata.largeThumbnail || metadata.smallThumbnail || source.url;
  };

  public getSmallThumbnail = (): string => {
    const [ metadata, source ] = this.getActiveItemThumbnailWithSource();
    return metadata.smallThumbnail || metadata.largeThumbnail || source.url;
  };

  public getCurrentCuePointId = (): string => {
    return this.currentCuePointId;
  };

  public getCurrentCuePointIndex = (): number => {
    return this.currentCuePointIndex;
  };

  public setActiveItem = (slide: IPresenterSlideEntity): void => {
    if (!slide) {
      return;
    }
    const cuePointId: string = slide.getCuePointId();
    this.activeItem = slide;
    this.setCurrentCuePointId(cuePointId);
    this.setCurrentCuePointIndex(cuePointId);
  };

  public updateCurrentIndexAfterWSChanges = (): void => {
    this.setCurrentCuePointIndex(this.activeItem.getCuePointId());
  };

  private setCurrentCuePointId = (cuePointId: string): void => {
    this.currentCuePointId = cuePointId;
  };

  private setCurrentCuePointIndex = (cuePointId: string): void => {
    const slides: IPresenterSlideEntity[] = this.slideManagementEntity.getSlides();
    this.currentCuePointIndex = slides.findIndex((slideEntity: IPresenterSlideEntity) => {
      return slideEntity.getCuePointId() === cuePointId;
    });
  };

  private getActiveItemThumbnailWithSource = (): [ CuePointMetadata, SourceWithoutProperties] => {
    const metadata: CuePointMetadata = this.activeItem.getCuePointMetadata();
    const source: SourceWithoutProperties = this.activeItem.getCuePointSource();

    return [ metadata, source ];
  };
}

export { PresenterActivePointer };
